import {
  useIsFeatureActive,
  useIsSoftFeatureToggleActive,
} from '@aboutyou/feature-flags';
import {Price} from '@aboutyou/grpc-clients/tadarida/aysa_api/models//price.types';
import {PriceV2} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/price_v2.types';
import {PushNotificationType} from '@aboutyou/ui-components';
import {useCallback, useState} from 'react';

export const useShowPushNotification = () => {
  const [pushNotificationType, setPushNotificationType] =
    useState<PushNotificationType>('a2w_l_push_trg');
  const [showPushNotification, setShowPushNotification] = useState(false);

  const pushNotificationEnabled = useIsSoftFeatureToggleActive(
    'web_mobile_push_notifications',
  );
  const {isActive: isPriceDisplayOverhaulV2Active} = useIsFeatureActive(
    'ab_price_display_overhaul_v2',
  );

  const updateShowPushNotification = useCallback(
    (input?: (Price | PriceV2 | undefined) | PushNotificationType) => {
      if (pushNotificationEnabled) {
        if (typeof input === 'string') {
          setPushNotificationType(input);
        } else {
          const hasReduction = isPriceDisplayOverhaulV2Active
            ? (input as PriceV2).badge?.length > 0
            : (input as Price)?.reductions.length > 0;
          if (hasReduction) {
            setPushNotificationType('a2w_l_push_trg');
          } else {
            setPushNotificationType('a2w_s_push_trg');
          }
        }
        setShowPushNotification(true);
      } else {
        setShowPushNotification(false);
      }
    },
    [isPriceDisplayOverhaulV2Active, pushNotificationEnabled],
  );
  return {
    pushNotificationType,
    showPushNotification,
    updateShowPushNotification,
  };
};
